import React from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from 'components/global/checkbox/Checkbox';
import Radio from 'components/global/radio/Radio';
import { useAssessmentContext } from 'services/context/assessmentContext/useAssessmentContext';

const QuestionSelect = ({ formikProps }) => {
  const { t } = useTranslation();
  const {
    currentSlot,
    state: { currentSlotId }
  } = useAssessmentContext();
  const { can_select_multiple, content, options } = currentSlot.question;

  const renderSelect = formikProps => {
    // TODO: handle languages instead of hardcoding to first
    let stringOptions = options.map(option =>
      option.content[0] ? option.content[0].text_display : 'No option given'
    );
    switch (can_select_multiple) {
      case true:
        return (
          <Checkbox
            name={currentSlotId}
            label={content[0] ? content[0].text_display : 'No label given'}
            description={t('mcQuestion.selectMultipleOptions')}
            formikProps={formikProps}
            options={stringOptions}
            selectTotal={stringOptions.length}
          />
        );
      default:
        return (
          <Radio
            name={currentSlotId}
            label={content[0] ? content[0].text_display : 'No label given'}
            description={t('mcQuestion.selectSingleOption')}
            formikProps={formikProps}
            options={stringOptions}
          />
        );
    }
  };

  return <>{renderSelect(formikProps)}</>;
};

export default QuestionSelect;
